import { useCallback } from "react";

import { useImageLightbox } from "@/shared/components/image-lightbox-context";

import { useItemActions } from "../store";
import type { Item } from "../types";
import { useRecordItemView } from "./use-record-item-view";

export function useOpenItemPreview() {
  const { openPreview } = useItemActions();
  const { openImageLightbox } = useImageLightbox();
  const recordItemView = useRecordItemView();

  return useCallback(
    (item: Item, items: Item[] = [item]) => {
      if (item.format === "image") {
        const images = items.flatMap((candidate) =>
          candidate.format === "image" && candidate.url
            ? [{
                alt: candidate.title || "图片预览",
                id: candidate.id,
                src: candidate.url,
              }]
            : [],
        );
        openImageLightbox(images, item.id, recordItemView);
        return;
      }

      openPreview(item.id);
    },
    [openImageLightbox, openPreview, recordItemView],
  );
}
